export default __webpack_public_path__ + "static/media/Earrings.84ff0e13.jpg";